import { ErrorBoundary } from '@libs/templates/template-pages';
import { Route } from 'react-router';
import { AuthorizedContainer } from './layout';

export const systemManagementRouter = (
  <Route
    path="/system-management"
    element={<AuthorizedContainer />}
    errorElement={<ErrorBoundary isUnderSubsystem={false} />}
  >
    <Route index lazy={async () => import('./pages/MainMenu')} />
    <Route path="/system-management/main-menu" lazy={async () => import('./pages/MainMenu')} />
    <Route path="/system-management/api-key-mst/*" lazy={async () => import('./pages/ApiKeyIndex')} />
    <Route path="/system-management/login-user-mst/*" lazy={async () => import('./pages/LoginUserIndex')} />
    <Route path="/system-management/role-mst/*" lazy={async () => import('./pages/RoleIndex')} />
    <Route path="/system-management/policy-mst/*" lazy={async () => import('./pages/PolicyIndex')} />
    <Route path="/system-management/rule-mst/*" lazy={async () => import('./pages/RuleIndex')} />
    <Route path="/system-management/company-info/*" lazy={async () => import('./pages/CompanyInfoIndex')} />
    <Route
      path="/system-management/password-policy"
      lazy={async () => import('./pages/PasswordPolicySetting')}
    />
    <Route path="/system-management/sso" lazy={async () => import('./pages/SsoSetting')} />
    <Route path="/system-management/target-mst/*" lazy={async () => import('./pages/TargetIndex')} />
    <Route
      path="/system-management/knowledge-base-mst/*"
      lazy={async () => import('./pages/KnowledgeBaseMstIndex')}
    />
    <Route path="*" lazy={async () => import('@libs/templates/template-pages/NotFound')} />
  </Route>
);
